import React from "react"
import "./_style.scss"
import { sanitize } from "§/src/utils/functions";

const HeroText = ({
  background,
  pretitle,
  title,
  description,
  titletag,
  content,
  ...props
}) => {
  const compClassName = "hero-text"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  return (
    <div
      comp={compClassName}
      className={
        compClass +
        (props?.rounded ? " border-rounded" : "") +
        (" bg-" + background)
      }
    >
      <div className={"d-flex flex-column"}>
        <div className={"d-flex flex-column gap-1"}>
          {pretitle && (
            <p className={"pretitle"} dangerouslySetInnerHTML={{__html: sanitize( pretitle )}} />
          )}
          {title && titletag === "h1" && (
            <h1 className={"h1 text-white fw-bold mb-0"} dangerouslySetInnerHTML={{__html: sanitize( title )}} />
          )}
          {title && titletag === "h2" && (
            <h2 className={"h1 text-white fw-bold mb-0"} dangerouslySetInnerHTML={{__html: sanitize( title )}} />
          )}
          {title && titletag === undefined && (
            <h1 className={"h1 text-white fw-bold mb-0"} dangerouslySetInnerHTML={{__html: sanitize( title )}} />
          )}
          {description && (
            <p className={"h3 text-white mb-0"} dangerouslySetInnerHTML={{__html: sanitize( description )}} />
          )}
          {content && (
            <p className={"text-white opacity-75 pe-lg-12 mt-2 mb-0"} dangerouslySetInnerHTML={{__html: sanitize( content )}} />
          )}
        </div>
      </div>
    </div>
  )
}

export default HeroText
